import { render, staticRenderFns } from "./capture.vue?vue&type=template&id=decf467e&"
import script from "./capture.vue?vue&type=script&lang=js&"
export * from "./capture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports